module.exports = __webpack_public_path__ + "img/eg-cn-04.723c9922.png";